import React from 'react';
import './MainHeader.css';
import Icon from '@avtechsoftware/react-component-library/src/components/common/Icon/Icon';
import { Dropdown } from 'react-bootstrap';
import PropTypes from 'prop-types';
import md5 from 'md5';
import { RaaRoles } from '../../../utility/SecurityRules';
import HasRolePrivileges from '../../highorder/HasRolePrivileges';

/* istanbul ignore next */
const genericDropdownToggle = React.forwardRef((
  {
    children,
    // eslint-disable-next-line react/prop-types
    onClick,
  }, ref,
) => (
  <div
    href=""
    onClick={(e) => {
      e.preventDefault();
      onClick(e);
    }}
    ref={ref}
    style={{ cursor: 'pointer' }}
  >
    {children}
  </div>
));
/* istanbul ignore next */
function MainHeader(props) {
  const { emailAddress, toggleSidebar, messageCount } = props;
  // const profileDropdownRef = React.forwardRef(genericDropdownToggle);
  const messagesBellColor = messageCount > 0 ? 'bg-color-red' : 'bg-color-grayDark';
  return (
    <div className="main-layout-header">
      <header id="main-header">
        <div id="main-header-logo">
          <a title="User Welcome Page" href="/user/welcome">
            <img src="/s/style/img/RAA_Header.svg" alt="Room Alert ®" />
            {' '}
          </a>
        </div>
        <div id="main-header-nav">
          <div className="main-header-nav-item">
            <a
              className="text-link"
              href="https://avtech.com/Products/Environment_Monitors/"
            >
              Products
            </a>
          </div>
          <div className="main-header-nav-item">
            <a className="text-link" href="https://avtech.com/support/">Support</a>
          </div>
          <div className="main-header-nav-item">
            <a href="/user/messages" className={`badge badge-pill badge-secondary ${messagesBellColor}`}>
              <Icon icon="bell" />
              {' '}
              {messageCount > 0 ? messageCount : ''}
            </a>
          </div>
          <div className="main-header-nav-item main-header-profile-button ">
            <Dropdown>
              <Dropdown.Toggle as={genericDropdownToggle} className="dropdown-menu dropdown-menu-right text-left">
                <div className="main-header-button main-header-profile-button " data-toggle="dropdown">
                  <img
                    src={`//www.gravatar.com/avatar/${md5(emailAddress.trim()).toLowerCase()}?d=mm&amp;s=25`}
                    alt="avatar"
                    title="Profile"
                  />
                </div>
              </Dropdown.Toggle>
              <Dropdown.Menu>
                <Dropdown.Item className="profile-dropdown-item disabled">
                  <span className="text-muted">
                    {emailAddress}
                  </span>
                </Dropdown.Item>
                <Dropdown.Divider />
                <Dropdown.Item className="profile-dropdown-item" href="/user">
                  Profile Settings
                </Dropdown.Item>
                <Dropdown.Item className="profile-dropdown-item" href="/user/subscriptions">
                  Accounts
                </Dropdown.Item>
                <Dropdown.Item className="profile-dropdown-item" href="/user/messages">
                  Messages
                </Dropdown.Item>
                <HasRolePrivileges
                  targetRoleList={[RaaRoles.ADMIN, RaaRoles.BILLING]}
                >
                  <>
                    <Dropdown.Divider />
                    <Dropdown.Item className="profile-dropdown-item" href="/s/subscription/billing">
                      Manage Billing
                    </Dropdown.Item>
                  </>
                </HasRolePrivileges>
                <Dropdown.Divider />
                <Dropdown.Item className="profile-dropdown-item" href="/gateway/logout">
                  Logout
                </Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>

          </div>
          <div
            className="main-header-nav-item main-header-button main-header-collapse-menu-button"
          >
            <div title="Collapse Menu" onClick={toggleSidebar}>
              <Icon icon="align-justify" className="fa text-muted" />
            </div>
          </div>

        </div>
      </header>
    </div>
  );
}

MainHeader.propTypes = {
  emailAddress: PropTypes.string.isRequired,
  toggleSidebar: PropTypes.func.isRequired,
  messageCount: PropTypes.number.isRequired,
};

export default MainHeader;
